'use strict'

const {htmlTag} = require('../helpers/imageServiceConstants')
const {isObjectFitBrowserSupport} = require('../helpers/browserFeatureSupport')
const backgroundAttributes = require('../engines/attributes/backgroundAttributes')
const imgAttributes = require('../engines/attributes/imgAttributes')
const SVGAttributes = require('../engines/attributes/SVGAttributes')
const imgPolyfillAttributes = require('../engines/attributes/imgPolyfillAttributes')

/**
 * get CSS or SVG attributes to be used in the browser
 * @param {object}                  transformsObj    transform parts object
 * @param {ImageTransformTarget}    target
 *
 * @returns object
 */
function getAttributes(transformsObj, target) {
    let attributesGetter

    if (target.htmlTag === htmlTag.BG) {
        attributesGetter = backgroundAttributes
    } else if (target.htmlTag === htmlTag.SVG) {
        attributesGetter = SVGAttributes
    } else if (isObjectFitBrowserSupport()) {
        attributesGetter = imgAttributes
    } else {
        attributesGetter = imgPolyfillAttributes
    }

    return attributesGetter.get(transformsObj, target)
}

module.exports.getAttributes = getAttributes
